import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { goBackToHistory } from '../utils/history-navigation-utils';

@Component({
  selector: 'app-history-result',
  templateUrl: './history-result.component.html',
  styleUrls: ['./history-result.component.scss']
})
export class HistoryResultComponent implements OnInit {

  isSavingRecord;
  individualData = JSON.parse(localStorage.getItem('historyData'))

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  goBack() {
    goBackToHistory(this.location);
  }

}
